// Make a new range array from start and end numbers
// input: [...range(0, 10)]
// output: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
export const range = (start, end) => Array.from({ length: end - start }, (v, k) => k + start);
//# sourceMappingURL=range.js.map